<form [formGroup]="questionForm" novalidate>
    <ion-textarea formControlName="current" [attr.maxlength]="maxLength" [placeholder]="placeholder ? placeholder : ''" class="ion-textarea"></ion-textarea>
    <div *ngIf="maxLength" class="textarea-counter">{{ questionForm.value.current?.length || 0 }} / {{ maxLength }}</div>
</form>
